import PauseAccountHelper from './helper';

const pauseAccountError = new PauseAccountHelper();

export { default as PauseAccountManager } from './pause-account-manager/pause-account-manager';
export default pauseAccountError;
